import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { take, tap } from 'rxjs/operators';
import { PricingPlanEnum } from 'src/app/enums/pricing-plan.enum';
import { PricingModalPageComponent } from 'src/app/pages/payments-call-back/pricing-modal/pricing-modal.page';
import { AuthService } from 'src/app/services/auth.service';
import { SubscriptionService } from './subscription.service';
import { StorageService } from 'src/app/services/shared/storage.service';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[checkSubscription]'
})
export class SubscriptionDirective {

    constructor(
        private modalController: ModalController,
        private subscriptionService: SubscriptionService,
        private storageService: StorageService,
        private loadingController: LoadingController,
        private authService: AuthService
    ) { }

    @Input() clickEvent;
    @Input() planPermissions: Array<PricingPlanEnum>;
    @Output() hasSubscription = new EventEmitter<any>();

    @HostListener('click', ['$event, $event.target'])
    async onClick(event) {
        (await this.loadingController.create({ message: 'Loading...' })).present();
        if (await this.checkSubscription()) {
            this.hasSubscription.emit();
        } else {
            event.stopPropagation();
            event.preventDefault();
            event.cancelBuble = true;
            event.stopImmediatePropagation();

            const user = await this.authService.userData.pipe(take(1)).toPromise()
            await this.openModal('PLAN ACTUAL LIMITADO', user);
        }
    }

    async checkSubscription() {
        return this.subscriptionService.hasActiveSubscription(await this.storageService.get('token'), this.planPermissions).pipe(
            tap(async () => await this.loadingController.dismiss())
        ).toPromise();
    }

    async openModal(message, user) {
        const modal = await this.modalController.create({
            component: PricingModalPageComponent,
            cssClass: 'pricing-modal-class',
            componentProps: {
                'showCurrentPlan': {
                    'message': message,
                    'availableSpace': null,
                    'spaceToUse': null,
                    'idPlan': user.subscription?.id_plan?.id_plan ?? null
                }
            },
            backdropDismiss: false
        });
        modal.onDidDismiss()
            .then((dataModal: any) => {
                const data = dataModal.data.dismissed;
                // console.log(data);
                //missing handler
            });
        await modal.present();
    }
}
